<template>
    <div>
        <Spinner v-if="loading" />
        <form @submit.prevent="confirm">
            <template v-if="schema">
                <FormField
                    v-for="(field, key) in schema"
                    :key="key"
                    :name="key"
                    :required="field.required"
                    :error="error"
                >
                    <PasswordFormInput
                        v-if="
                            field.type === 'string' && (key === 'password1' || key === 'password2')
                        "
                        v-model="form[key]"
                        :placeholder="field.label"
                    />
                    <FormField v-else v-model="form[key]" :name="key" :placeholder="field.label" />
                </FormField>
            </template>
            <button class="button button--big button--fullwidth">
                {{ button.label }}
            </button>
        </form>
    </div>
</template>

<script>
import { FormField, PasswordFormInput } from '@speechki-frontend/shared/ui/forms';

import { fetchCustomersInvite, confirmCustomersInvite } from '../../api/customers';

function createFormFields(schema = {}) {
    return Object.entries(schema).reduce((acc, [key, field]) => {
        acc[key] = typeSchemaValue(field);
        return acc;
    }, {});
}

function typeSchemaValue(field) {
    if (field.default_value) {
        return field.default_value;
    }

    switch (field.type) {
        case 'string':
            return '';

        default:
            return undefined;
    }
}

export default {
    name: 'CustomersInviteForm',
    components: {
        FormField,
        PasswordFormInput,
    },
    props: {
        code: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            invite: {},

            form: {},

            loading: false,
            error: null,
        };
    },

    computed: {
        schema() {
            if (!this.invite.form) return null;

            return this.invite.form.schema;
        },
        button() {
            if (!this.invite.form) return {};

            return this.invite.form.button;
        },
    },

    async created() {
        try {
            this.loading = true;
            this.invite = await fetchCustomersInvite(this.code);
            if (this.invite.form && this.invite.form.schema) {
                this.form = createFormFields(this.invite.form.schema);
            }
            this.loading = false;
        } catch {
            this.loading = false;
        }
    },

    methods: {
        async confirm() {
            try {
                this.loading = true;

                await confirmCustomersInvite(this.invite.form.confirm_url, this.form);

                this.$store.dispatch('pushToast', {
                    type: 'success',
                    title: "Invitation accepted. You'll be redirected to the login page now..",
                    text: 'Repeat the action again, or reload the page.',
                });

                setTimeout(() => {
                    this.$router.push({ name: 'login' });
                }, 1500);

                this.error = null;
            } catch (error) {
                console.log(error);
                this.error = error;
                this.$store.dispatch('pushToast', {
                    type: 'error',
                    title: `${error.response.status} ${error.response.statusText}`,
                    text: 'Please try again later',
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
